import React from "react";
import Lottie from "react-lottie";
import loader from "../images/spinner.json";
const CTAButton = ({ fill, title, onClick, textColor, color, loading }) => {
  const loaderOptions = {
    loop: true,
    autoplay: true,
    animationData: loader,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <div
      onClick={onClick}
      className="cta-button"
      style={{
        background: fill ? color : null,
        color: textColor,
        borderColor: color,
      }}
    >
      <div
        className="lot-wrap"
        style={{ justifyContent: loading ? "space-between" : "center" }}
      >
        <p>{loading ? "Connecting..." : title}</p>
        {loading ? (
          <Lottie options={loaderOptions} width={25} style={{ margin: 0 }} />
        ) : null}
      </div>
    </div>
  );
};

export default CTAButton;
